import React from 'react';

import CyberReportContainer from '@totem/components/cyberReview/CyberReportContainer';
import NameSearch from '@totem/components/cyberReview/NameSearch';
import ReportTable from '@totem/components/cyberReview/ReportTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

import './cyberReport.css';

const CyberReportPage = () => {
  return (
    <ContentLayout>
      <CyberReportContainer>
        <IBCard isCovered>
          <NameSearch />
          <br />
          <ReportTable />
        </IBCard>
      </CyberReportContainer>
    </ContentLayout>
  );
};

export default CyberReportPage;
